const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  JOE_WAVAX: "0x454e67025631c065d3cfad6d71e6892f74487a15"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.JOE_WAVAX]: 0
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.JOE_WAVAX]: 2
};

const PAIR_ADDRESS_TO_NATIVE_REWARDS = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.JOE_WAVAX]: [false, true]
};

module.exports = {
  ADDRESS: "0x188bed1968b795d5c9022f6a0bb5931ac4c18f00",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH,
  PAIR_ADDRESS_TO_NATIVE_REWARDS
};
